import Carrito from '../../spa/carrito/Carrito';

export default {
  path: 'carrito',
  name: 'carrito',
  component: Carrito,
};



// WEBPACK FOOTER //
// ./src/config/router/carrito.js